import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import {OtherActivityDetails} from './otherActiviteDetails';
import { ConnectionTypes } from '../../../../../constants/utils/connectionTypes'

export const OtherActivity = () => {
    const [activityState, setActivityState] = useState({
        items: []
    });
    const services = useSelector(state => state.services);
    const user = useSelector(state => state.user);

    const activityVector =  services.serviceData[ConnectionTypes.otherActivity];
    useEffect(() => {
        let activitiesInState = !R.isNil(services) && !R.isNil(services.serviceData) && !R.isNil(services.serviceData[ConnectionTypes.otherActivity]) ? services.serviceData[ConnectionTypes.otherActivity] : [];
        if (activitiesInState.length > 0){
            setActivityState({
                items: activitiesInState
            });
        }else{
            setActivityState({...activityState, items: activityState.items.concat({})});
        }
    }, [services.serviceData, activityVector]);

    function removeActivity(activity) {
        setActivityState({...activityState, items: activityState.items.filter(a => a !== activity)});
    }

    return (
        <article className="block" id="autre activité">
            <h3 className="sr-only visually-hidden">autre activité</h3>
            {
                activityState.items.map((activity, index) => {
                    return <OtherActivityDetails key={index} index={index} user={user} activity={activity} removeActivity={removeActivity}/>
                })
                    
            }

            <footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
                <h4 className="sr-only visually-hidden">Ajouter une autre ACTIVITÉ</h4>
                <button type="button" className="btn btn-icon btn-alert-info mx-auto py-2" disabled={activityState.items.findIndex(item => JSON.stringify(item) === JSON.stringify({})) !== -1} onClick={(e) => {
                    const nodes = window.document.querySelectorAll('.collapse.show');
                    if (!R.isNil(nodes) && nodes.length > 0) {
                        nodes.forEach(element => {
                            element.classList.remove(['show']);
                        });
                    }
                    setActivityState({ ...activityState, items: activityState.items.concat({}) });
                }}>
                    <i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter une autre ACTIVITÉ
				</button>
            </footer>
        </article>
    )
}